export default __webpack_public_path__ + "e304f081e92c9f66f4657c0e4cd5704b.png";